import Swal from "sweetalert2";

export function showSpinnerCustom(title, text) {
    Swal.fire({
        title: title,
        html: text,
        timerProgressBar: true,
        didOpen: () => {
            Swal.showLoading();
        }
    });
}

export function showMessageCustom(title, text, onOk) {
    Swal.fire({
        title: title,
        html: text,
        confirmButtonText: "OK",
    }).then((result) => {
        if (result.isConfirmed && typeof onOk === "function") {
            onOk(); // Execute the provided callback function
        }
    });
}
